import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
	NProgress.start();
	document.title = "MetaEra";
	const hasToken = getToken();

	if (hasToken) {
		if (to.path === "/login") {
			next({ path: "/" });
			NProgress.done();
		} else {
			const hasGetUserInfo = store.getters.name;
			if (hasGetUserInfo) {
				const role_permissions = store.state.user.user.role_permissions; // 假设格式是 "100,200,300"
				if (role_permissions) {
					const permissionArray = role_permissions.split(",").map(Number); // 转换为数字数组
					const requiredPermission = to.meta.permission;
					if (
						permissionArray.includes(requiredPermission) ||
						requiredPermission === 0 ||
						requiredPermission === 100
					) {
						console.log(`User has permission: ${requiredPermission}`, to.path);

						next();
					} else {
						Message.error("您没有权限访问此页面");
						router.push("/login");
						NProgress.done();
					}
				} else {
					Message.error("您没有权限访问此页面");
					next(false);
				}
			} else {
				try {
					await store.dispatch("user/getInfo");
					next({ ...to, replace: true });
				} catch (error) {
					await store.dispatch("user/resetToken");
					Message.error(error || "Has Error");
					next(`/login?redirect=${to.path}`);
					NProgress.done();
				}
			}
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			next();
		} else {
			next(`/login?redirect=${to.path}`);
			NProgress.done();
		}
	}
});

router.afterEach(() => {
	// finish progress bar
	NProgress.done();
});
